import { Messages } from '../../../codegen/Localize';
import { Order } from '../../../ts/helpers/Order';
import { OrderKeys } from '../../../ts/models/OrderKeys';
import { SortOptions } from '../../../ts/models/sort/CommonSortOptions';
import { OptionsDictionary } from '../../../ts/models/sort/SortOptionDefinitions';

export const flowSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  'owner': SortOptions.owner,
  'containerName': SortOptions.containerName,
  'updated': SortOptions.updated,
};

export const FlowConnectionsSortOptions: OptionsDictionary = {
  'type': SortOptions.connectionType
};

export const runFlowTasksSortOptions: OptionsDictionary = {
  'schedule' : SortOptions.schedule,
  'priority' : {
    id: OrderKeys.priority,
    getMenuItemDisplayValue: Messages.column_task_priority,
    subSortOptions: {
      'asc': {
        id: 'priority.asc',
        field: OrderKeys.priority,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.priority)]
      },
      'desc': {
        id: 'priority.desc',
        field: OrderKeys.priority,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.priority)]
      }
    }
  },
  'runNextAt' : SortOptions.runNextAt,
};

export const flowOutputStepRunSortOptions: OptionsDictionary = {
  'flowOutputStepName': {
    id: OrderKeys.flowOutputStepName,
    getMenuItemDisplayValue: Messages.flowRunHistoryColumn_output,
    subSortOptions: {
      'asc': {
        id: 'flowOutputStepName.asc',
        field: OrderKeys.flowOutputStepName,
        getMenuItemDisplayValue: Messages.sortByAZ,
        getButtonDisplayValue: Messages.sortByOutputStepAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.flowOutputStepName)]
      },
      'desc': {
        id: 'flowOutputStepName.desc',
        field: OrderKeys.flowOutputStepName,
        getMenuItemDisplayValue: Messages.sortByZA,
        getButtonDisplayValue: Messages.sortByOutputStepDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.flowOutputStepName)]
      },
    },
  },
  'startedAt': {
    id: OrderKeys.startedAt,
    getMenuItemDisplayValue: Messages.flowRunHistoryColumn_runStart,
    subSortOptions: {
      'desc': {
        id: 'startedAt.desc',
        field: OrderKeys.startedAt,
        getMenuItemDisplayValue: Messages.sortByNewOld,
        getButtonDisplayValue: Messages.sortByRunStartDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.startedAt)]
      },
      'asc': {
        id: 'startedAt.asc',
        field: OrderKeys.startedAt,
        getMenuItemDisplayValue: Messages.sortByOldNew,
        getButtonDisplayValue: Messages.sortByRunStartAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.startedAt)]
      },
    },
  },
  'completedAt': {
    id: OrderKeys.completedAt,
    getMenuItemDisplayValue: Messages.flowRunHistoryColumn_runEnd,
    subSortOptions: {
      'desc': {
        id: 'completedAt.desc',
        field: OrderKeys.completedAt,
        getMenuItemDisplayValue: Messages.sortByNewOld,
        getButtonDisplayValue: Messages.sortByRunEndDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.completedAt)]
      },
      'asc': {
        id: 'completedAt.asc',
        field: OrderKeys.completedAt,
        getMenuItemDisplayValue: Messages.sortByOldNew,
        getButtonDisplayValue: Messages.sortByRunEndAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.completedAt)]
      },
    },
  },
  'status': {
    id: OrderKeys.status,
    getMenuItemDisplayValue: Messages.flowRunHistoryColumn_status,
    subSortOptions: {
      'asc': {
        id: 'status.asc',
        field: OrderKeys.status,
        getMenuItemDisplayValue: Messages.sortByAZ,
        getButtonDisplayValue: Messages.sortByStatusAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.status)]
      },
      'desc': {
        id: 'status.desc',
        field: OrderKeys.status,
        getMenuItemDisplayValue: Messages.sortByZA,
        getButtonDisplayValue: Messages.sortByStatusDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.status)]
      },
    },
  },
  'rowsProduced': {
    id: OrderKeys.rowsProduced,
    getMenuItemDisplayValue: Messages.flowRunHistoryColumn_rowsGeneratedTitle,
    subSortOptions: {
      'desc': {
        id: 'rowsProduced.desc',
        field: OrderKeys.rowsProduced,
        getMenuItemDisplayValue: Messages.sortByMostLeast,
        getButtonDisplayValue: Messages.sortByRowsGeneratedDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.rowsProduced)]
      },
      'asc': {
        id: 'rowsProduced.asc',
        field: OrderKeys.rowsProduced,
        getMenuItemDisplayValue: Messages.sortByLeastMost,
        getButtonDisplayValue: Messages.sortByRowsGeneratedAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.rowsProduced)]
      },
    },
  },
  'siteName'  : SortOptions.siteName
};
